import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmdComponent } from './simple-icons-amd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmdComponent ],
    exports:      [ SimpleIconsAmdComponent ],
    bootstrap:    []
})
export class SimpleIconsAmdModule {}
